// var animOffset = 600,
// 	animQ,
// 	scrollThreshold = 0.85;
// $(function(){
// 	var animItems = $('.project-header, .project-footer, .project-content');
// 	animItems.addClass('anim-queued');
// 	function revealItem(item){
// 		item.addClass('anim-revealed');
// 	}
// 	$('body').addClass('animated');
// 	body.on('scrolld',function(){			
// 		var scrolld = window.scrollY;
// 		$('.anim-queued').each(function(){			
// 			if($(this).offset().top < scrolld + scrollThreshold * winH){
// 				revealItem($(this))
// 			}
// 		});
// 	});
// });
